import React, { useState } from 'react'
import LoginLayout from '../../layouts/Login'
import ImageLogin from '../../assets/ImageLogin.png'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../utils/errorApi'

import styles from './styles.module.css'
import { useLoading } from '../../hooks/LoadingContext'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'

const ChangePassword: React.FC = () => {
  const navigate = useNavigate()
  let { token, email } = useParams()
  const { isLoading, setIsLoading } = useLoading()
  const [password, setPassword] = useState<string>('')
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>('')

  const handleSubmit = async (event: any) => {
    setIsLoading(true)
    event.preventDefault()

    try {
      await api.put(`/users/password/recovery`, {
        token: token,
        email: email,
        newPassword: password,
        newPassword_confirmation: passwordConfirmation,
      })

      toast.info('Senha alterada com sucesso!')
      navigate('/login')
    } catch (err) {
      toast.error(errorApi(err, 'Não foi possível alterar a senha!'))
    }
    setIsLoading(false)
  }

  const isValidModel = () => {
    return password && passwordConfirmation
  }

  return (
    <LoginLayout backgroundColor="#fff" imageSrc={ImageLogin}>
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <h1
        style={{
          fontWeight: '500',
          fontSize: 26,
          color: '#667080',
          marginTop: 15,
        }}
      >
        Alterar senha
      </h1>
      <Form>
        <Row style={{ marginTop: 15, textAlign: 'left' }}>
          <Col>
            <Form.Label className={styles.newPasswordLabel}>Nova senha</Form.Label>
            <Form.Control
              className={styles.newPasswordInput}
              type="password"
              placeholder="Digite aqui sua nova senha"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 15, textAlign: 'left' }}>
          <Col>
            <Form.Label className={styles.newPasswordLabel}>Confirme a nova senha</Form.Label>
            <Form.Control
              className={styles.newPasswordInput}
              type="password"
              placeholder="Digite novamente a sua nova senha"
              value={passwordConfirmation}
              onChange={(event) => setPasswordConfirmation(event.target.value)}
            />
          </Col>
        </Row>
        <Col style={{ textAlign: 'right', marginTop: 10 }}>
          <span>
            <Link to="/login" style={{ color: '#053C5E', fontWeight: '500' }}>
              Voltar para login
            </Link>{' '}
          </span>
        </Col>
        <Col className="d-grid" style={{ marginTop: 15 }}>
          <Button
            className={styles.changePasswordBtn}
            variant="primary"
            type="submit"
            disabled={isLoading || !isValidModel()}
            onClick={(event) => handleSubmit(event)}
          >
            {isLoading ? (
              <Spinner
                animation="border"
                size="sm"
                style={{
                  color: '#fff',
                  marginRight: 10,
                }}
              />
            ) : (
              'Alterar senha'
            )}
          </Button>
        </Col>
      </Form>
    </LoginLayout>
  )
}

export default ChangePassword
